module.exports = __webpack_public_path__ + "static/media/equipamentos.6b084a6d.jpg";